<div
  id="menu-container"
  [ngClass]="{ isadmin: isAdmin, open: menu.open }"
  (mouseenter)="openmenu()"
  (mouseleave)="closemenu()">
  <div class="menu-wrapper">
    <div class="logo-wrapper">
      <a class="logo-item" [routerLink]="'/'">
        <img class="logo-img" src="/assets/img/3ddv/logo-3ddv-icon-white.svg" alt="Menu" />
        <span class="logo-title">Venue <span class="sub-text">Workspace.</span></span>
      </a>
    </div>
    <div class="services-wrapper">
      <div class="service-wrapper-item">
        <!-- Menu link with tooltip (disabled) -->
        <!-- <a
          *ngFor="let service of publicServices"
          class="menu-item"
          [ngClass]="{ selected: service.path === currentServicePath }"
          tooltip="{{ service.publicname }}"
          containerClass="tooltipCustom open{{ menu.open }}"
          placement="right"
          [delay]="0"
          [routerLink]="service.path"> -->
        <a
          *ngFor="let service of publicServices"
          class="menu-item"
          [ngClass]="{ selected: service.path === currentServicePath }"
          [routerLink]="service.path">
          <img [src]="service.icon" [alt]="service.name + ' icon'" />
          <span [hidden]="!menu.open">
            {{ service.publicname }}
          </span>
          <!-- <img [src]="servicesIconsPath + 'icon-' + service.name + '.svg'" alt="" /> -->
        </a>
      </div>
    </div>
  </div>
</div>
